// Environment variable validation for Static Web App
export const checkEnvironmentVariables = () => {
  const requiredVars = [
    'REACT_APP_API_BASE_URL',
    'REACT_APP_AZURE_FRONTEND_CLIENT_ID',
    'REACT_APP_AZURE_TENANT_DOMAIN',
    'REACT_APP_AZURE_TENANT_ID',
    'REACT_APP_AZURE_BACKEND_API_ID',
    'REACT_APP_REDIRECT_URI'
  ];

  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    console.error('❌ Missing environment variables:', missing);
    if (process.env.NODE_ENV !== 'production') {
      console.error('Current environment variables:', {
        REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
        REACT_APP_AZURE_FRONTEND_CLIENT_ID: process.env.REACT_APP_AZURE_FRONTEND_CLIENT_ID,
        REACT_APP_AZURE_TENANT_DOMAIN: process.env.REACT_APP_AZURE_TENANT_DOMAIN,
        REACT_APP_AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID,
        REACT_APP_AZURE_BACKEND_API_ID: process.env.REACT_APP_AZURE_BACKEND_API_ID,
        REACT_APP_REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI
      });
      console.error('All process.env keys:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
    }
    return false;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.log('✅ All environment variables are set');
  }
  return true;
};
